// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"index__page-spinner___1IzGS","pageSpinner":"index__page-spinner___1IzGS","spin":"index__spin___87oXp","small":"index__small___2Guqk"};